// TensaiGame logic converted from Python
// Handles grid generation, clearing squares, reset, score, seed


class TensaiGame {
  constructor({ rows = 6, cols = 6, seed = null } = {}) {
    this.rows = rows;
    this.cols = cols;
    this.seed = seed || TensaiGame.generateSeed();
    this.score = 0;
    this.grid = this.generateGrid();
  }

  static generateSeed() {
    // Generate a random 10-character alphanumeric seed
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < 10; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }

  // Seeded random generator (same as Python)
  random(seed) {
    let s = typeof seed === "string" ? this.hashSeed(seed) : seed;
    return function() {
      s = (s * 9301 + 49297) % 233280;
      return s / 233280;
    };
  }

  hashSeed(seed) {
    // Simple hash for string seed
    let hash = 0;
    for (let i = 0; i < seed.length; i++) {
      hash = seed.charCodeAt(i) + ((hash << 5) - hash);
    }
    return Math.abs(hash);
  }

  generateGrid() {
    // Even distribution of 1-9, shuffled
    const totalCells = this.rows * this.cols;
    let numbers = [];
    for (let i = 1; i <= 9; i++) {
      for (let j = 0; j < Math.ceil(totalCells / 9); j++) {
        numbers.push(i);
      }
    }
    numbers = numbers.slice(0, totalCells);
    // Shuffle with seeded random
    const rand = this.random(this.seed);
    for (let i = numbers.length - 1; i > 0; i--) {
      const j = Math.floor(rand() * (i + 1));
      [numbers[i], numbers[j]] = [numbers[j], numbers[i]]; // eslint-disable-line security/detect-object-injection -- Fisher-Yates shuffle with numeric loop indices
    }
    // Build grid
    let grid = [];
    for (let r = 0; r < this.rows; r++) {
      grid.push(numbers.slice(r * this.cols, (r + 1) * this.cols));
    }
    return grid;
  }

  clearSquares(selected) {
    // selected: array of [row, col] pairs
    const total = selected.reduce((sum, [r, c]) => sum + (this.grid[r][c] || 0), 0); // eslint-disable-line security/detect-object-injection -- 2D grid access with destructured numeric row/col
    if (total === 10) {
      let clearedCount = 0;
      selected.forEach(([r, c]) => {
        if (this.grid[r][c] != null) { // eslint-disable-line security/detect-object-injection -- 2D grid access with destructured numeric row/col
          this.grid[r][c] = null; // eslint-disable-line security/detect-object-injection -- 2D grid access with destructured numeric row/col
          clearedCount++;
        }
      });
      this.score += clearedCount;
      return true;
    }
    return false;
  }

  reset(seed = null) {
    this.seed = seed || TensaiGame.generateSeed();
    this.score = 0;
    this.grid = this.generateGrid();
  }
}

export default TensaiGame;
